import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex flex-wrap align-items-end gap-3" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "card-body p-15 p-sm-20 p-md-25"
}
const _hoisted_7 = { class: "fw-medium mb-15" }
const _hoisted_8 = {
  key: 0,
  class: "table-responsive mb-25"
}
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = {
  key: 1,
  class: "fw-medium mb-15 text-danger"
}
const _hoisted_11 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_12 = { class: "table text-nowrap align-middle mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-label fs-13 mb-5" }, "Année oct.–déc. (ex. 2025)", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.anneeOct) = $event)),
            type: "number",
            class: "form-control",
            style: {"max-width":"140px"},
            min: "2000",
            max: "2100"
          }, null, 512), [
            [
              _vModelText,
              _ctx.anneeOct,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label fs-13 mb-5" }, "Année janv.–mai (ex. 2026)", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.anneeJanMai) = $event)),
            type: "number",
            class: "form-control",
            style: {"max-width":"140px"},
            min: "2000",
            max: "2100",
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onAnneeJanMaiChange && _ctx.onAnneeJanMaiChange(...args)))
          }, null, 544), [
            [
              _vModelText,
              _ctx.anneeJanMai,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label fs-13 mb-5" }, "Date limite de paiement (optionnel)", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dateLimitePaiement) = $event)),
            type: "date",
            class: "form-control",
            style: {"max-width":"200px"}
          }, null, 512), [
            [_vModelText, _ctx.dateLimitePaiement]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label fs-13 mb-5" }, "Fichier Excel (.xlsx)", -1)),
          _createElementVNode("input", {
            type: "file",
            class: "form-control",
            accept: ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onFile && _ctx.onFile(...args)))
          }, null, 32)
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary align-self-end",
          type: "button",
          disabled: !_ctx.fichier || _ctx.loading,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.importer && _ctx.importer(...args)))
        }, _toDisplayString(_ctx.loading ? "Traitement…" : "Générer les factures"), 9, _hoisted_4),
        (_ctx.facturesCreees.length && _ctx.factureIdsAnnulables.length)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-outline-danger align-self-end",
              disabled: _ctx.loading,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.annulerDernierLotFactures && _ctx.annulerDernierLotFactures(...args)))
            }, " Annuler ce lot (" + _toDisplayString(_ctx.factureIdsAnnulables.length) + " facture(s)) ", 9, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-body-secondary fs-13 mb-0 mt-10 px-15 px-sm-20 px-md-25" }, [
        _createTextVNode(" Les libellés et la période de facture utilisent ces deux années : par exemple "),
        _createElementVNode("strong", null, "oct.–déc. 2025"),
        _createTextVNode(" et "),
        _createElementVNode("strong", null, "janv.–mai 2026"),
        _createTextVNode(". Par défaut, janv.–mai = oct.–déc. + 1 ; modifiez la deuxième année si besoin. Sans date limite renseignée, la date est calculée comme pour les autres factures (règle métier serveur). ")
      ], -1))
    ]),
    (_ctx.facturesCreees.length || _ctx.lignesRejetees.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("h6", _hoisted_7, "Factures créées (" + _toDisplayString(_ctx.facturesCreees.length) + ")", 1),
          (_ctx.facturesCreees.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "text-uppercase fs-13" }, "Id"),
                      _createElementVNode("th", { class: "text-uppercase fs-13" }, "Référence"),
                      _createElementVNode("th", { class: "text-uppercase fs-13" }, "Code place"),
                      _createElementVNode("th", { class: "text-uppercase fs-13" }, "Montant")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facturesCreees, (s, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: 's-' + i
                      }, [
                        _createElementVNode("td", null, _toDisplayString(s.id), 1),
                        _createElementVNode("td", null, _toDisplayString(s.reference), 1),
                        _createElementVNode("td", null, _toDisplayString(s.codePlace), 1),
                        _createElementVNode("td", null, _toDisplayString(s.montant), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.lignesRejetees.length)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_10, "Rejets (" + _toDisplayString(_ctx.lignesRejetees.length) + ")", 1))
            : _createCommentVNode("", true),
          (_ctx.lignesRejetees.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("table", _hoisted_12, [
                  _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "text-uppercase fs-13" }, "Code place"),
                      _createElementVNode("th", { class: "text-uppercase fs-13" }, "Motif")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lignesRejetees, (r, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: 'r-' + i
                      }, [
                        _createElementVNode("td", null, _toDisplayString(r.codePlace), 1),
                        _createElementVNode("td", null, _toDisplayString(r.motif), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}